var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-recent",class:_vm.version == 'horiz'?'h-17':'h-19'},[(_vm.serviceNumStatus)?_c('div',{attrs:{"id":"ui-server"}}):_c('NoneData',{staticClass:"flex",attrs:{"tips":"加载中...","version":_vm.version}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aef802c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LineBarHome.vue
// module id = null
// module chunks = 